import React from 'react';
import { Box } from '@mui/material';

const G1 = '#9FE870', G2 = '#163300', G3 = '#4caf50', G4 = '#2e7d32', BG = '#f0faf0';
const R = ({ x, y, w, h, fill, rx = 3, opacity = 1, style }) => <rect x={x} y={y} width={w} height={h} rx={rx} fill={fill} opacity={opacity} style={style} />;
const T = ({ x, y, size = 6, fill = G2, weight = 400, opacity = 1, children }) => <text x={x} y={y} fontSize={size} fill={fill} fontWeight={weight} fontFamily="Inter,sans-serif" opacity={opacity}>{children}</text>;

const bars = [
  { label: 'Jan', rev: 0.55, exp: 0.30 },
  { label: 'Feb', rev: 0.62, exp: 0.35 },
  { label: 'Mar', rev: 0.48, exp: 0.28 },
  { label: 'Apr', rev: 0.78, exp: 0.40 },
  { label: 'May', rev: 0.65, exp: 0.32 },
  { label: 'Jun', rev: 0.90, exp: 0.42 },
  { label: 'Jul', rev: 0.72, exp: 0.38 },
];

const ReportingMockup = () => {
  const W = 480, H = 300;
  const chartX = 58, chartY = 148, chartW = 200, chartH = 100;
  const bw = 12, gap = (chartW - bars.length * bw * 2 - (bars.length - 1) * 4) / bars.length;

  return (
    <Box sx={{ width: '100%', maxWidth: 520, position: 'relative', filter: 'drop-shadow(0 20px 40px rgba(22,51,0,0.20))', '& svg': { display: 'block', width: '100%', height: 'auto' } }}>
      <style>{`
        @keyframes rfU{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}
        @keyframes rBar{from{transform:scaleY(0)}to{transform:scaleY(1)}}
      `}</style>
      <svg viewBox={`0 0 ${W} ${H}`} xmlns="http://www.w3.org/2000/svg">
        <defs><linearGradient id="rg" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="white" stopOpacity="0.06"/><stop offset="100%" stopColor="white" stopOpacity="0"/></linearGradient></defs>
        <R x={0} y={0} w={W} h={H} fill={BG} rx={12} />
        {/* chrome */}
        <R x={0} y={0} w={W} h={26} fill={G2} rx={12} />
        <R x={0} y={14} w={W} h={12} fill={G2} />
        <circle cx={13} cy={13} r={4} fill="#ff5f57" />
        <circle cx={25} cy={13} r={4} fill="#febc2e" />
        <circle cx={37} cy={13} r={4} fill="#28c840" />
        <T x={W/2-24} y={17} size={7} fill={G1} weight={700}>Reports</T>
        {/* sidebar */}
        <R x={0} y={26} w={50} h={H-26} fill={G2} />
        <R x={12} y={34} w={26} h={26} fill={G1} rx={6} />
        <T x={18} y={51} size={9} fill={G2} weight={800}>F</T>
        {[
          { icon: '▦', label: 'Dash',    y: 74  },
          { icon: '◈', label: 'P&L',     y: 94  },
          { icon: '⊞', label: 'Balance', y: 114 },
          { icon: '◉', label: 'CashFlow',y: 134 },
          { icon: '≡', label: 'Reports', y: 154, active: true },
          { icon: '✦', label: 'AI',      y: 174 },
        ].map(({ icon, label, y, active }) => (
          <g key={label}>
            {active && <R x={0} y={y-8} w={50} h={20} fill={G1} opacity={0.15} rx={0} />}
            {active && <R x={0} y={y-8} w={3}  h={20} fill={G1} rx={0} />}
            <T x={15} y={y+4}  size={8}   fill={active ? G1 : 'white'} opacity={active ? 1 : 0.4}>{icon}</T>
            <T x={8}  y={y+14} size={4.5} fill={active ? G1 : 'white'} opacity={active ? 1 : 0.3}>{label}</T>
          </g>
        ))}

        {/* topbar */}
        <R x={50} y={26} w={W-50} h={22} fill="white" opacity={0.55} />
        <T x={58} y={41} size={7} fill={G2} weight={700}>Profit & Loss — Q2 2025</T>
        {['PDF', 'Excel'].map((btn, i) => (
          <g key={btn}>
            <R x={W-90+i*44} y={31} w={36} h={12} fill={i===0?'#ef4444':G4} rx={6} opacity={0.85} />
            <T x={W-84+i*44} y={40} size={5.5} fill="white" weight={700}>↓ {btn}</T>
          </g>
        ))}

        {/* KPI cards */}
        {[
          { label: 'Total Revenue',  value: '$248.4K', sub: '↑ 14.2%', color: G3,        x: 56  },
          { label: 'Total Expenses', value: '$98.6K',  sub: '↓ 3.1%',  color: '#ef4444', x: 140 },
          { label: 'Gross Profit',   value: '$149.8K', sub: '↑ 22.4%', color: G4,        x: 224 },
          { label: 'Net Margin',     value: '60.3%',   sub: '↑ 4.1pp', color: G1,        x: 308 },
        ].map(({ label, value, sub, color, x }, i) => (
          <g key={label} style={{ animation: `rfU 0.5s ${0.1+i*0.1}s ease both` }}>
            <R x={x} y={52} w={78} h={42} fill="white" rx={5} />
            <R x={x} y={52} w={3}  h={42} fill={color} rx={2} />
            <T x={x+7} y={63}  size={5.5} fill={G2} opacity={0.5}>{label}</T>
            <T x={x+7} y={78}  size={9}   fill={G2} weight={700}>{value}</T>
            <T x={x+7} y={89}  size={5.5} fill={color} weight={600}>{sub}</T>
          </g>
        ))}

        {/* grouped bar chart */}
        <g style={{ animation: 'rfU 0.6s 0.3s ease both' }}>
          <R x={chartX} y={chartY-10} w={chartW+10} h={chartH+18} fill="white" rx={5} />
          <T x={chartX+6} y={chartY} size={6} fill={G2} weight={700}>Revenue vs Expenses</T>
          {/* legend */}
          <R x={chartX+130} y={chartY-6} w={8} h={5} fill={G3} rx={1} />
          <T x={chartX+140} y={chartY-2} size={5} fill={G2} opacity={0.6}>Revenue</T>
          <R x={chartX+170} y={chartY-6} w={8} h={5} fill="#ef4444" rx={1} opacity={0.6} />
          <T x={chartX+180} y={chartY-2} size={5} fill={G2} opacity={0.6}>Expenses</T>
          {/* axis */}
          <line x1={chartX+6} y1={chartY+chartH-2} x2={chartX+chartW+4} y2={chartY+chartH-2} stroke={G2} strokeOpacity={0.1} strokeWidth={1} />
          {bars.map((b, i) => {
            const bx = chartX + 8 + i * (bw * 2 + gap + 6);
            const rh = b.rev * (chartH - 20);
            const eh = b.exp * (chartH - 20);
            return (
              <g key={b.label}>
                <rect x={bx}    y={chartY+chartH-2-rh} width={bw} height={rh} rx={2} fill={G3} opacity={0.8}
                  style={{ transformOrigin: `${bx+bw/2}px ${chartY+chartH-2}px`, animation: `rBar 0.8s ${0.1*i+0.4}s cubic-bezier(.34,1.56,.64,1) both` }} />
                <rect x={bx+bw+2} y={chartY+chartH-2-eh} width={bw} height={eh} rx={2} fill="#ef4444" opacity={0.5}
                  style={{ transformOrigin: `${bx+bw+2+bw/2}px ${chartY+chartH-2}px`, animation: `rBar 0.8s ${0.1*i+0.5}s cubic-bezier(.34,1.56,.64,1) both` }} />
                <T x={bx+2} y={chartY+chartH+8} size={5} fill={G2} opacity={0.5}>{b.label}</T>
              </g>
            );
          })}
        </g>

        {/* P&L summary table */}
        <g style={{ animation: 'rfU 0.6s 0.4s ease both' }}>
          <R x={270} y={138} w={202} h={130} fill="white" rx={5} />
          <T x={278} y={150} size={6.5} fill={G2} weight={700}>P&L Summary</T>
          {[
            { label: 'Sales Revenue',    value: '$248,400', color: G3 },
            { label: 'Cost of Sales',    value: '($98,600)', color: '#ef4444' },
            { label: 'Gross Profit',     value: '$149,800', color: G4, bold: true },
            { label: 'Operating Exp.',   value: '($42,200)', color: '#ef4444' },
            { label: 'Net Profit',       value: '$107,600', color: G4, bold: true },
          ].map(({ label, value, color, bold }, i) => (
            <g key={label}>
              {bold && <R x={272} y={156+i*22} w={194} h={18} fill={G1} rx={3} opacity={0.08} />}
              <T x={278} y={168+i*22} size={6}   fill={G2} weight={bold?700:400} opacity={bold?1:0.8}>{label}</T>
              <T x={400} y={168+i*22} size={6}   fill={color} weight={700}>{value}</T>
            </g>
          ))}
        </g>

        <R x={0} y={0} w={W} h={H} fill="url(#rg)" rx={12} />
      </svg>
      <Box aria-hidden sx={{ position:'absolute', inset:'-1px', borderRadius:'13px', border:'1px solid rgba(22,51,0,0.10)', pointerEvents:'none' }} />
    </Box>
  );
};

export default ReportingMockup;
